import React, { useMemo } from 'react';
import { View } from 'react-native';
import i18n from 'i18n-js';

import ActionMenu from '@components/common/actionMenu';
import { fullWidth, scale } from '@components/frame';
import { useHandleParams } from '@v2/pages/machines/hooks/useHandleParams';
import { isPhone } from '@helpers';
import { useHandleNavigationMachinesHeader } from '@v2/pages/machines/hooks/useHandleNavigationMachineHeader';
import { connect } from 'react-redux';
import { setSelectedMachine } from '@reducers/machines';
import { ALL_MACHINES_OBJECT } from '@v2/pages/common/constants/base.constants';
import { getElevation } from '@styles/shadow';
import ModalWrapper from '@components/modal/ModalWrapper';

const GroupSelectModal = (props) => {
  const { C, groups, selectedGroup, setSelectedGroup, setIsGroupModalOpen, machines, machineStatistics, setSelectedMachine, isVisible, position } =
    props;

  const { id } = useHandleParams();
  const { shouldUseMachinesForList, isPerformanceSubScreen } = useHandleNavigationMachinesHeader();

  const renderArray = useMemo(() => {
    const allMachinesItem = {
      name: i18n.t('All Machines'),
      machineGroupId: null,
      id: 'all',
    };

    const machineItems = shouldUseMachinesForList ? machines : machineStatistics.data;

    if (!isPhone) {
      return [
        allMachinesItem,
        ...(groups.length > 0
          ? [
              {
                subtitle: true,
                name: i18n.t('Machine Groups'),
              },
              ...groups,
            ]
          : []),
      ];
    }

    return [
      allMachinesItem,
      ...(!isPerformanceSubScreen && groups.length
        ? [
            {
              subtitle: true,
              name: i18n.t('Machine Groups'),
            },
            ...groups,
          ]
        : []),
      {
        subtitle: true,
        name: i18n.t('Machines'),
      },
      ...machineItems.map((m) => ({ ...m, name: m.shortName })),
    ];
  }, [shouldUseMachinesForList, machines, machineStatistics.data, groups]);

  const items = renderArray.map((item) => {
    const selected =
      (!!selectedGroup?.machineGroupId && selectedGroup?.machineGroupId === item.machineGroupId) ||
      (selectedGroup && selectedGroup === item.machineGroupId) ||
      (selectedGroup === null && item.machineGroupId === null && !isPhone) ||
      (!selectedGroup && item.id === id);

    const selectedSize = selected && !item.subtitle ? 12 : 0;

    return {
      subtitle: !!item.subtitle,
      lable: {
        color: item.subtitle ? 'Label/Light/Tertiary' : 'Label/Light/Primary',
        name: item.name,
      },
      icon: {
        name: 'check',
        width: selectedSize,
        height: selectedSize,
        color: 'Button/Light/Primary',
      },
      onPress: () => {
        if (item.subtitle) return;
        setIsGroupModalOpen(false);

        if (item.machineGroupId || item.id === 'all') {
          setSelectedGroup(item.machineGroupId ? item : null);
          setSelectedMachine(ALL_MACHINES_OBJECT);
        } else {
          setSelectedMachine(item);
          isPhone && setSelectedGroup(null);
        }
      },
    };
  });

  const modalPosition = position || { top: scale(35), left: isPhone ? scale(9) : 0 };

  return (
    <ModalWrapper isVisible={isVisible} onBackdropPress={() => setIsGroupModalOpen(false)} C={C}>
      <View
        style={{
          width: scale(isPhone ? fullWidth - 53 : 335),
          position: 'absolute',
          top: modalPosition.top,
          left: modalPosition.left,
          backgroundColor: C('Background/Light/Field'),
          borderRadius: scale(12),
          elevation: getElevation('Field'),
        }}
      >
        <ActionMenu {...{ C, items }} />
      </View>
    </ModalWrapper>
  );
};

export default connect(({ machines: { machines, machineStatistics } }) => ({ machines, machineStatistics }), {
  setSelectedMachine,
})(GroupSelectModal);
